import { useState } from "react";
import { SortConfig } from "@shared/types/table";

export const useTableSort = () => {
  const [sortArray, setSortArray] = useState<string[]>([]);
  const [sortConfig, setSortConfig] = useState<SortConfig | undefined>();

  const handleSort = (field: string, direction: 'asc' | 'desc') => {
    console.log('Sort requested:', field, direction);

    const newSortArray = [...sortArray];
    const fieldIndex = newSortArray.findIndex(item =>
      item === field || item === `-${field}`
    );

    if (fieldIndex !== -1) {
      newSortArray.splice(fieldIndex, 1);
    }

    const currentState = sortArray.find(item => item === field)
      ? 'asc'
      : sortArray.find(item => item === `-${field}`)
      ? 'desc'
      : 'none';

    let nextState: 'asc' | 'desc' | 'none';

    if (currentState === 'none') {
      nextState = 'asc';
    } else if (currentState === 'asc') {
      nextState = 'desc';
    } else {
      nextState = 'none';
    }

    if (nextState === 'asc') {
      newSortArray.push(field);
      setSortConfig({ field, direction: 'asc' });
    } else if (nextState === 'desc') {
      newSortArray.push(`-${field}`);
      setSortConfig({ field, direction: 'desc' });
    } else {
      setSortConfig(undefined);
    }

    setSortArray(newSortArray);
    console.log('Updated sort array:', newSortArray);
  };

  return {
    sortArray,
    sortConfig,
    handleSort,
  };
};
